import { render, staticRenderFns } from "./SidebarNext.vue?vue&type=template&id=f87f18b2&scoped=true"
import script from "./SidebarNext.vue?vue&type=script&lang=js"
export * from "./SidebarNext.vue?vue&type=script&lang=js"
import style0 from "./SidebarNext.vue?vue&type=style&index=0&id=f87f18b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87f18b2",
  null
  
)

export default component.exports